(function(Backbone, _, $) {

  // Use strict mode.
  'use strict';

  /**
   * Configurator handler.
   */
  var ConfiguratorView = Backbone.View.extend({

    el: "",
    events: {
      'click .cfgFormCheckboxSpan': '_clickCheck',
      'click .cfgFormRadioSpan': '_clickRadio',
      'change input[type=radio]': '_changeRadio',
      'change input[type=checkbox]': '_changeCheck'
    },


    initialize: function(options) {
      /*
      this.$('.cfgFormRadioSpan').each(function() {
        var $t = $(this);
        var $checked = $t.find('input').is(':checked');
        console.log($checked);
              if ($checked) {
                  $t.addClass('active');
              }
      });
      */
    },
    /*

    render: function() {
    },
    */

    _clickCheck: function(e) {
      var $t = $(e.target);
      if ($t.prop("tagName") == 'INPUT') {
        return;
      }
      var $inp = $t.find('input');
      if (!$inp.prop('checked')) {
        $inp.prop('checked',true).trigger('change');
      } else {
        $inp.prop('checked',false).trigger('change');
      }
    },

    _clickRadio: function(e) {
      var $t = $(e.currentTarget);
      var $checked = $t.find('input').is(':checked');
      if (!$checked) {
        $t.find('input').prop('checked',true).trigger('change');
      }
    },

    _changeRadio: function(e) {
      var $t = $(e.target);
      var $checked = $t.prop('checked');
      if ($checked) {
        var $p = $t.parent();
        $t.parent().addClass('active').parent().find('.active').not($p).removeClass('active');
      } else {
        $t.parent().removeClass('active');
      }
    },

    _changeCheck: function(e) {
      var $t = $(e.currentTarget);
      var $p = $t.parent();
      if ($t.prop('checked')) {
        $p.addClass('active');
      } else {
        $p.removeClass('active');
      }
    }
  });

  $(".cfg").each(function() {
    var cv = new ConfiguratorView( { el: $(this) } );
  });


})(Backbone, _, jQuery);
